import { RootState } from './index';
import { Quote } from '../types/quote';

/**
 * Select all quotes
 */
export const selectAllQuotes = (state: RootState): Quote[] => {
  return state.quotes.quotes;
};

/**
 * Select quote count
 */
export const selectQuoteCount = (state: RootState): number => {
  return state.quotes.quotes.length;
};

/**
 * Select a quote by ID
 */
export const selectQuoteById = (state: RootState, id: string): Quote | undefined => {
  return state.quotes.quotes.find((q) => q.id === id);
};

/**
 * Select the current daily quote ID
 */
export const selectDailyQuoteId = (state: RootState): string | null => {
  return state.quotes.dailyQuoteId;
};

/**
 * Select the last selected date
 */
export const selectLastSelectedDate = (state: RootState): string | null => {
  return state.quotes.lastSelectedDate;
};

/**
 * Select the current daily quote object
 * Returns null if no daily quote is set
 */
export const selectDailyQuote = (state: RootState): Quote | null => {
  const dailyQuoteId = state.quotes.dailyQuoteId;
  if (!dailyQuoteId) return null;

  return state.quotes.quotes.find((q) => q.id === dailyQuoteId) || null;
};

/**
 * Check if quotes collection is empty
 */
export const selectIsEmpty = (state: RootState): boolean => {
  return state.quotes.quotes.length === 0;
};

/**
 * Select quotes sorted by creation date (newest first)
 */
export const selectQuotesSortedByNewest = (state: RootState): Quote[] => {
  return [...state.quotes.quotes].sort((a, b) => b.createdAt - a.createdAt);
};

/**
 * Select quotes sorted by update date (most recently updated first)
 */
export const selectQuotesSortedByRecent = (state: RootState): Quote[] => {
  return [...state.quotes.quotes].sort((a, b) => b.updatedAt - a.updatedAt);
};
